<!--
 * @Author: gaozhaodong
 * @Date: 2023-04-30 09:38:25
 * @Description: file content
 * @FilePath: /parking_bmw_h5/src/views/invoice/invoicing.vue
-->
<template>
  <div id="ping">
    <Header :headerTitle="$t('m.invoicing.title')"></Header>
    <van-cell class="u-cell-row" @click="invoicingList" is-link size="large">
      <template #title>
        <b-img left  :src="require('../../assets/img/kaipiaodingdan.png')" width="20"/>
        <span class="title">{{$t('m.invoicing.title')}}</span>
      </template>
    </van-cell>
    <van-cell class="u-cell-row" @click="historyInvoicing" is-link size="large">
      <template #title>
        <b-img left  :src="require('../../assets/img/lishi.png')" width="20"/>
        <span class="title">{{$t('m.invoicing.list')}}</span>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  name: "invoicing",
  data() {
    return {};
  },

  methods: {
    //进入开票订单页面
    invoicingList: function() {
      this.$router.push("/invoicingList");
    },
    //进入开票开票历史
    historyInvoicing: function() {
      this.$router.push("/historyInvoicing");
    }
  }
};
</script>

<style scoped>
a {
  color: #2c3e50;
}

a:link {
  text-decoration: none;
  color: #2c3e50;
}

p {
  font-family: HiraginoSansGB-W6;
}
#ping {
  height: 100%;
  background-color: #f5f5f5;
}
.help-item {
  text-align: left;
  height: 65px;
  line-height: 55px;
  padding: 0px 10px;
  background-color: #fff;
}

.help-item p {
  border-bottom: 1px solid #d5d5d5;
  padding-left: 20px;
  margin-bottom: 0px;
}
.help-item:last-child p {
  border-bottom: none;
}

.call-btn {
  width: 100%;
  position: absolute;
  bottom: 20px;
  text-align: center;
}

.call-btn button {
  background-color: #0066B1;
  width: 90%;
  padding: 10px;
}
</style>